<!--
 * @Author: 裴纬华
 * @Date: 2021-08-19 11:31:13
 * @LastEditors: 裴纬华
 * @LastEditTime: 2021-12-27 15:44:31
 * @Description: content
-->
<template>
  <div class="mine">
    <div class="block-card">
      <br />
      <template  v-for="item in FinanceReportComponents" >
        <div  v-if="item.meta&&item.meta.title"  :key="item.path" >
             <van-cell :icon='item.meta.icon'  :title="item.meta.title"  is-link  :to="'/financial-report/'+item.path"  />
             <br />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {FinanceReportComponents} from '@/router'
export default {
  data() {
    return {
      showClientList: false
    };
  },
  computed: {
    ...mapGetters(["currClient"]),
    FinanceReportComponents(){
      return FinanceReportComponents
    }
  }
};
</script>
<style lang="less">
.mine {
  .mine-head {
    margin: 1.5rem;
    padding: 0.5rem;
    background: #eee;
    border-radius: 10px;
  }
  .block-card {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/index.vue